import React, { useState, useEffect, useRef } from "react";
import {
  Wrapper,
  InfoWrapper,
  Icon,
  Name,
  InfoLeft,
  InfoRight,
  Inputs,
  InputWrapper,
} from "./styled";
import isEmpty from "lodash/isEmpty";
import Input from "../Input";
import produce from "immer";
import ValidationBar from "../common3/ValidationBar";

const labels = {
  workplace: "Arbetsplats",
  phone: "Telefon",
  phoneDaytime: "Telefon dagtid",
  email: "E-post",
};

const defaultValue = {
  workplace: "",
  phone: "",
  phoneDaytime: "",
  email: "",
};

export const useIsMount = () => {
  const isMountRef = useRef(false);
  useEffect(() => {
    isMountRef.current = true;
  }, []);
  return isMountRef.current;
};

const SecondGuardian = (props) => {
  const isMounted = useIsMount();

  const {
    builder = false,
    formData = {},
    nodes = {},
    extra = {},
    id,
    save = () => {},
    value = undefined,
    validationError = {},
    user = {},
    sampleGuardian = {},
    origin,
    disabled,
  } = props;
  const { icon = true, childSelectorName = undefined } = extra;

  const childSelector = Object.values(nodes).find(
    ({ extra = {} }) => extra.name === childSelectorName
  );

  // const [mounted, setMounted] = useState(false)
  const [guardian, setGuardian] = useState(builder ? sampleGuardian : {});
  const [values, setValues] = useState(value || defaultValue);

  // effect if childselector updates
  useEffect(() => {
    if (builder) {
      return;
    }

    if (!formData[childSelector._id] || !formData[childSelector._id].length) {
      setGuardian({});
      return;
    }

    const { guardians = [] } = formData[childSelector._id][0];

    const selectedChildGuardian = guardians.find(
      ({ personnummer }) => personnummer !== user.personnummer
    );

    if (
      selectedChildGuardian &&
      guardian.personnummer !== selectedChildGuardian.personnummer
    ) {
      setGuardian(selectedChildGuardian);
    }
  }, [formData]);

  // effect
  useEffect(() => {
    if (!isMounted) {
      return;
    }

    // Removed this origin check to make sure that the SecondGuardian email and phone number can be edited and saved from the admin-page

    // if (origin === 'admin') {
    //   return
    // }

    if (builder) {
      return;
    }
    // REMOVED BECAUSE NOGUARDIAN WAS SET ON EVERY FORM.
    // const { personnummer } = formData[id] || {}

    // if (guardian.personnummer === personnummer) {
    //   if( values.noGuardian === 1 ) {
    //     return
    //   }
    //   setValues({ noGuardian : 1})
    //   return
    // }

    if (JSON.stringify(value) === JSON.stringify({ ...guardian, ...values })) {
      return;
    }

    save({ key: id, value: { ...guardian, ...values } });
  }, [guardian /* , isMounted */]);

  useEffect(() => {
    if (!isMounted) {
      return;
    }

    // Removed this origin check to make sure that the SecondGuardian email and phone number can be edited and saved from the admin-page

    // if (origin === 'admin') {
    //   return
    // }

    if (builder) {
      return;
    }

    save({ key: id, value: { ...guardian, ...values } });
  }, [values]);

  if (!childSelector) {
    return null;
  }

  const onChange = ({ key, value }) => {
    setValues(
      produce((d) => {
        d[key] = value;
      })
    );
  };

  if (!builder && isEmpty(guardian)) {
    return null;
  }

  // if sec. guardian is selected, then we pick value from value. If not we pick from guardian. This is to ensure that we render the correct person in both admin and portal

  let {
    givenName,
    familyName,
    personnummer,
    address = {},
  } = value && value.personnummer ? value : guardian;

  const { streetAddress = "", postalCode = "", addressLocality = "" } = address;

  if (origin === "admin" && !value) {
    return null;
  }

  return (
    <>
      <Wrapper className="SecondGuardian">
        <InfoWrapper>
          <Name>
            {icon && <Icon className="far fa-user-friends" />}
            {givenName + " " + familyName}
          </Name>
        </InfoWrapper>
        <InfoWrapper>
          <InfoLeft>Personnr</InfoLeft>
          <InfoRight>{personnummer}</InfoRight>
        </InfoWrapper>
        <InfoWrapper>
          <InfoLeft>Adress</InfoLeft>
          <InfoRight>{streetAddress}</InfoRight>
        </InfoWrapper>
        <InfoWrapper>
          <InfoLeft>Postnr</InfoLeft>
          <InfoRight>{postalCode}</InfoRight>
        </InfoWrapper>
        <InfoWrapper>
          <InfoLeft>Ort</InfoLeft>
          <InfoRight>{addressLocality}</InfoRight>
        </InfoWrapper>
        <Inputs>
          <InputWrapper>
            <Input
              label="E-post"
              disabled={disabled}
              value={values.email}
              id="email"
              save={({ key, value }) => onChange({ key, value })}
              height="40"
              debounceTimer={0}
            />
          </InputWrapper>
          {Object.entries(values).map(([key, value], i) => {
            /**
             * prevent unwanted value to leak into secondguardigan
             */
            switch (key) {
              case "workplace":
              case "phone":
              case "phoneDaytime":
              case "email":
                break;
              default:
                return null;
            }

            if (!extra[key]) {
              return null;
            }

            return (
              <InputWrapper key={i}>
                <Input
                  disabled={disabled}
                  label={labels[key]}
                  value={value}
                  id={key}
                  save={({ key, value }) => onChange({ key, value })}
                  height="40"
                  debounceTimer={0}
                />
              </InputWrapper>
            );
          })}
        </Inputs>
      </Wrapper>
      {!isEmpty(validationError) && (
        <ValidationBar
          error={
            validationError.critical
              ? "Du måste ange en korrekt e-postadress"
              : "Vänligen ange en korrekt e-postadress"
          }
        />
      )}
    </>
  );
};

export default SecondGuardian;
